import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface SukhaCardProps {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  hover?: boolean;
}

export function SukhaCard({
  children,
  className = "",
  noPadding = false,
  hover = true,
}: SukhaCardProps) {
  return (
    <div
      className={cn(
        hover && "hover:scale-[1.02]",
        "transition-all duration-100 ease-in-out",
        "transform origin-center",
        "w-full flex",
        noPadding ? "p-0" : "px-2 py-4 sm:p-4",
        "bg-slate-900/85",
        "bg-gradient-to-br from-[var(--gradient-primary-start)] to-[var(--gradient-primary-end)]",
        "backdrop-blur-md",
        "rounded-2xl",
        "shadow-sm shadow-slate-800/10 ring-1 ring-slate-200/10",
        className
      )}
    >
      {children}
    </div>
  );
}
